import { Injectable } from '@angular/core';
import { AssignmentData } from '../model/assignmentdata';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

    constructor(private common: CommonService) { }

    searchAll(filterString: string, data: AssignmentData[]): AssignmentData[] {
        const query = this.normalizeString(filterString);
        if (query === '') {
            return data;
        }

        return data.filter(x => {
            const consultants = x.assignedConsultants ?? [];

            return this.normalizeString(x.assignmentNumber).includes(query)
                || this.normalizeString(x.managerName).includes(query)
                || this.normalizeString(x.department).includes(query)
                || this.toDateNumberString(x.assignmentStartdate).includes(query)
                || this.toDateNumberString(x.assignmentEndDate).includes(query)
                || this.toDateNumberString(x.extendDate).includes(query)
                || consultants.some(cons =>
                    this.normalizeString(cons.consultantName).includes(query)
                    || this.normalizeString(cons.consultantNumber).includes(query)
                    || this.toDateNumberString(cons.consultantStartdate).includes(query)
                    || this.toDateNumberString(cons.consultantEnddate).includes(query)
                    || this.normalizeString(cons.reasonForEmplNeed).includes(query)
                    || this.normalizeString(cons.unitNumber).includes(query)
                );
        });
    }

    private normalizeString(value: unknown): string {
        if (value === null || value === undefined) {
            return '';
        }

        return String(value).toLowerCase().trim();
    }

    private toDateNumberString(date: Date): string {
        const dateAsNumber = this.common.dateAsNumber(date);
        return Number.isFinite(dateAsNumber) ? String(dateAsNumber) : '';
    }

    containsConsultantName(name: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(assign => 
            (assign.assignedConsultants
                .filter(cons => cons.consultantName.toLowerCase()
                .includes(name.toLowerCase().trim()))).length > 0 );
    }

    containsConsultantNumber(consNr: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(assign => 
            (assign.assignedConsultants
                .filter(cons => cons.consultantNumber
                .includes(consNr.trim()))).length > 0 );
    }

    containsConsultantStartDate(consStartDate: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(x => 
            (x.assignedConsultants
                .filter(cons => String(this.common.dateAsNumber(cons.consultantStartdate))
                .includes(consStartDate.trim()))).length > 0);
    }
  
    containsConsultantEndDate(consEndDate: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(x => 
            (x.assignedConsultants
                .filter(cons => String(this.common.dateAsNumber(cons.consultantEnddate))
                .includes(consEndDate.trim()))).length > 0);
    }

    containsReason(reason: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(x => 
            (x.assignedConsultants
                .filter(x => x.reasonForEmplNeed.toLowerCase().trim()
                .includes(reason.toLowerCase().trim()))).length > 0);
    }

    containsAssignmentNr(assignmentNr: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(x => 
            x.assignmentNumber
                .includes(assignmentNr.trim()))
    }

    containsAssignmentStartDate(assignmentStartDate: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(x => 
            String(this.common.dateAsNumber(x.assignmentStartdate))
                .includes(assignmentStartDate.trim()));
    }

    containsAssignmentEndDate(assignmentEndDate: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(x => 
            String(this.common.dateAsNumber(x.assignmentEndDate))
                .includes(assignmentEndDate.trim()));
    }

    containsExtendDate(extendDate: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(x => 
            String(this.common.dateAsNumber(x.extendDate))
                .includes(extendDate.trim()));
    } 

    hasUnitNr(unitNr: string, data: AssignmentData[]): AssignmentData[] {
        return unitNr == 'All' 
            ? data
            : data.filter(assign => 
                (assign.assignedConsultants.filter(cons => cons.unitNumber == unitNr.trim() )).length > 0 );

    }

    startsWithDepartment(dept: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(x => 
            x.department.toLowerCase()
                .startsWith(dept.toLowerCase().trim()))
    }

    containsManager(manager: string, data: AssignmentData[]): AssignmentData[] {
        return data.filter(x => 
            x.managerName.toLowerCase()
                .includes(manager.toLowerCase().trim()))
    }
  
}


